
<card #cardContainer
    [isCollapsible]="true">
    <div class="card-header-content"  (click)="menuToggleCard()">
        <div class="title">
            {{labels.title}}
        </div>
    </div>
    <div class="card-body-content">
        <div class="agency-column column">
            <div *ngIf="bookingData.agency">
                <label class="label-name">{{ labels.agency }} : </label>
                <strong>{{ bookingData.agency.name }}</strong>
                <ng-container *ngIf="bookingData.agency.code">
                    - <em>{{ bookingData.agency.code }}</em>
                </ng-container>
            </div>
            <div *ngIf="bookingTranslated?.agentName">
                <label class="label-name">{{ labels.agent }} : </label>
                <strong>{{ bookingTranslated.agentName }}</strong>
            </div>
            <div *ngIf="bookingTranslated?.agencyPhoneNumber || bookingTranslated?.agentEmail">
                {{ labels.contact }} :
                <div class="contact-content" *ngIf="bookingTranslated?.agencyPhoneNumber">
                    <fa-icon [icon]="iconPhone" class="icon"></fa-icon>
                    <strong>{{ bookingTranslated.agencyPhoneNumber }}</strong>
                </div>
                <div class="contact-content" *ngIf="bookingTranslated?.agentEmail">
                    <fa-icon [icon]="iconEnvelope" class="icon"></fa-icon>
                    <strong>{{ bookingTranslated.agentEmail }}</strong>
                </div>
            </div>
        </div>

        <div class="ref-column column" >
<!--            <div *ngFor="let ref of bookingData.booking?.externalBookingArray">-->
<!--                <div *ngIf="ref.code">-->
<!--                    {{ labels.reference }}-->
<!--                    <ng-container *ngIf="ref.xOrigin">-->
<!--                        {{transcodedOrigin[ref.xOrigin]}}-->
<!--                    </ng-container>-->
<!--                    <strong> {{ ref.host.code | hostAlias | async }} <interface-flag [interface]="ref.interface"></interface-flag>: {{ ref.code }} </strong>-->
<!--                </div>-->
<!--            </div>-->
            <external-booking [displayMode]="displayModes.booking" [externalBookings]="bookingData.booking?.externalBookingArray || bookingData.externalBooking"></external-booking>
        </div>

        <div class="version-column column">
            <div>
                {{ labels.version }} <strong>{{ bookingData.version || "1" }}</strong>
            </div>
        </div>
    </div>
</card>
